import { ComponentPropsWithRef } from "react";

export const FileIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M13.5 4H7.1C6.67565 4 6.26869 4.16857 5.96863 4.46863C5.66857 4.76869 5.5 5.17565 5.5 5.6V18.4C5.5 18.8243 5.66857 19.2313 5.96863 19.5314C6.26869 19.8314 6.67565 20 7.1 20H16.7C17.1243 20 17.5313 19.8314 17.8314 19.5314C18.1314 19.2313 18.3 18.8243 18.3 18.4V8.8L13.5 4ZM16.7 18.4H7.1V5.6H12.7V9.6H16.7V18.4Z"
      fill="currentColor"
    />
  </svg>
);
